export default __webpack_public_path__ + "static/media/lumisight.218d18d2.png";